import { useState } from 'react';
import BZAPIService from '../services/BZAPIService';

/**
 * Custom hook for managing vendor scheduling state
 * Provides state and functions for both interval and calendar scheduling modes
 */
export const useScheduling = () => {
  const [timeUnit, setTimeUnit] = useState('');
  const [timeValue, setTimeValue] = useState({});
  const [schedulingMode, setSchedulingMode] = useState('interval');
  const [schedules, setSchedules] = useState([]);
  const [nextRun, setNextRun] = useState();

  /**
   * Saves the bug service frequency schedule
   * Builds payload based on current scheduling mode (interval or calendar)
   * @param {string} vendorId - The vendor ID
   * @returns {Promise} - Resolves with API response
   */
  const saveBugServiceFrequency = async vendorId => {
    let data;

    if (schedulingMode === 'interval') {
      data = {
        mode: 'interval',
        timeUnit,
        number: parseInt(timeValue.value)
      };
    } else if (schedulingMode === 'calendar') {
      data = {
        mode: 'calendar',
        schedules: schedules.map(schedule => ({
          days: schedule.days,
          times: schedule.times
        }))
      };
    }

    if (vendorId && vendorId.length) {
      try {
        const res = await BZAPIService.postBugServiceSchedule(vendorId, data, { method: 'POST' });
        setNextRun(res?.data?.nextRunUTC || (res?.data?.rules && res?.data?.rules[0]?.nextRunUTC));
        return res;
      } catch (e) {
        console.log(e);
        throw e;
      }
    }
  };

  return {
    // State
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    // Functions
    saveBugServiceFrequency
  };
};
